import React, { useEffect, useRef, useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import FuelEuEmissionFactors from "./FuelEuEmissionFactors/FuelEuEmissionFactors";
import FuelEuSlippageCoefficient from "./FuelEuSlippageCoefficient/FuelEuSlippageCoefficient";
import "./FeuBasicData.scss";
import { FormProvider, useForm } from "react-hook-form";
import FeuB4OnShorePowerSupply from "./FeuB4OnShorePowerSupply/FeuB4OnShorePowerSupply";
import FeuCarbonCaptureandStorage from "./FeuCarbonCaptureandStorage/FeuCarbonCaptureandStorage";
import "./FeuBasicData.scss";
import FeuB5ZeroEmission from "./FeuB5ZeroEmissionTechnology/FeuB5ZeroEmissionTechnology";
import B1ShipDetails from "./FeuB1ShipDetails/FeuB1ShipDetails";
import FeuFuelConsumerProcedures from "./FeuFuelConsumerProcedures/FeuFuelConsumerProcedures";
import FeuEmissionFactorAnnex1 from "./FeuEmissionFactorAnnex1/FeuEmissionFactorAnnex1";
import FeuEmissionFactorAnnex2 from "./FeuEmissionFactorAnnex2/FeuEmissionFactorAnnex2";
import FeuB2CompanyInformation from "./FeuB2CompanyInformation/FeuB2CompanyInformation";
import FeuB3Consumers from "./FueB3Consumers/FeuB3Consumers";
import FeuB8EmissionfactorsAnnex1 from "./FeuB8UpdateProceduresOpsEquipment/FeuB8UpdateProceduresOpsEquipment";
import FeuB9EmissionfactorsAnnex2 from "./FeuB9EnergyEmissions/FeuB9EnergyEmissions";
import FeuB7WindAssistedPropulsion from "./FeuB7WindAssistedPropulsion/FeuB7WindAssistedPropulsion";
import FeuB6PowerDemandAtBerth from "./FeuB6PowerDemandAtBerth/FeuB6PowerDemandAtBerth";
import { useLocation } from "react-router-dom";

const BasicData = ({ data, dropdownData, refetchMonitoringData, onCreateVesselData, mode,vesselMstId }) => {
	const [expandedPanel, setExpandedPanel] = useState("panel1");

	const methods = useForm({
		mode: "onBlur",
		defaultValues: {
			NameOfTheShip: "",
		},
	});
   
	const autoSaveForB1=useRef();
	const autoSaveForB2=useRef();
	const autoSaveForB3 = useRef();
	const autoSaveForB31 = useRef();
	const autoSaveForB32 = useRef();
	const autoSaveForB33 = useRef();
	const autoSaveForB34 = useRef();
	const autoSaveForB35 = useRef();
	const autoSaveForB36 = useRef();
	const autoSaveForB4 = useRef();
	const autoSaveForB5 = useRef();
	const autoSaveForB6 = useRef();
	const autoSaveForB7 = useRef();
	const autoSaveForB8 = useRef();
	const autoSaveForB9 = useRef();

	const handleChange = (panel) => async (_, isExpanded) => {
		let isSubmitSuccess = true;
		if (expandedPanel === 'panel1' && autoSaveForB1.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB1.current.submitAndCheck();
        } else if (expandedPanel === 'panel2' && autoSaveForB2.current?.submitAndCheck) {
            isSubmitSuccess = await autoSaveForB2.current.submitAndCheck();
        }
		else if (expandedPanel === 'panel3' && autoSaveForB3.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB3.current.submitAndCheck();
		} else if (expandedPanel === 'panel3.1' && autoSaveForB31.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB31.current.submitAndCheck();
		} else if (expandedPanel === 'panel3.2' && autoSaveForB32.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB32.current.submitAndCheck();
		} else if (expandedPanel === 'panel3.3' && autoSaveForB33.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB33.current.submitAndCheck();
		} else if (expandedPanel === 'panel3.4' && autoSaveForB34.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB34.current.submitAndCheck();
		} else if (expandedPanel === 'panel3.5' && autoSaveForB35.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB35.current.submitAndCheck();
		} else if (expandedPanel === 'panel3.6' && autoSaveForB36.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB36.current.submitAndCheck();
		} else if (expandedPanel === 'panel4' && autoSaveForB4.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB4.current.submitAndCheck();
		} else if (expandedPanel === 'panel5' && autoSaveForB5.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB5.current.submitAndCheck();
		} else if (expandedPanel === 'panel6' && autoSaveForB6.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB6.current.submitAndCheck();
		} else if (expandedPanel === 'panel7' && autoSaveForB7.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB7.current.submitAndCheck();
		} else if (expandedPanel === 'panel8' && autoSaveForB8.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB8.current.submitAndCheck();
		} else if (expandedPanel === 'panel9' && autoSaveForB9.current?.submitAndCheck) {
			isSubmitSuccess = await autoSaveForB9.current.submitAndCheck();
		}
		if (!isSubmitSuccess) return;
		setExpandedPanel(isExpanded ? panel : false);
	};

	const renderTitleWithIcon = (panel, title) => (
		<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
			<span style={{ fontSize: "20px", fontWeight: "bold" }}>{expandedPanel === panel ? "−" : "+"}</span>
			<p className="fuel-cons">{title}</p>
		</div>
	);

	const handleAutoSave = (field, value) => {
		console.log(`Auto-saving field: ${field} = ${value}`);
	};
	 const b1ShipFormMethods = useForm();
     const b2CompanyFormMethods = useForm();
	 const location = useLocation();
	const query = new URLSearchParams(location.search);
	const isClone = query.get("shouldClone") === "true";

	return (
		<FormProvider {...methods}>
			<form>
				<Accordion defaultExpanded expanded={expandedPanel === "panel1"} onChange={handleChange("panel1")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon("panel1", "B.1 Identification of the ship and shipowner details")}
					</AccordionSummary>
					<AccordionDetails>
						<FormProvider {...b1ShipFormMethods}>
                       <B1ShipDetails
							ref={autoSaveForB1}
							onFieldAutoSave={handleAutoSave}
							B1ShipDetailsData={mode === "Create" ? (isClone ? data?.b1ShipIdentification : onCreateVesselData) : data?.b1ShipIdentification}
							monitoringData={data?.b1ShipIdentification}
							B1ShipDropdownValues={dropdownData}
							refetchMonitoringData={refetchMonitoringData}
							vesselMstId={vesselMstId}
						/>
                        </FormProvider>

					</AccordionDetails>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel2"} onChange={handleChange("panel2")} className="mt-3">
					<AccordionSummary className="accordion-header">{renderTitleWithIcon("panel2", "B.2 Company Information")}</AccordionSummary>
					<AccordionDetails>
						<FormProvider {...b2CompanyFormMethods}><FeuB2CompanyInformation ref={autoSaveForB2} b2CompanyInfo={data?.b2CompanyInfo} b2CompanyInfoValues={dropdownData?.companyNatures} refetchMonitoringData={refetchMonitoringData}
						vesselMstId={vesselMstId} />
                        </FormProvider>
					</AccordionDetails>
				</Accordion>

				<Accordion expanded={expandedPanel === "panel3"} onChange={handleChange("panel3")} className="mt-3">
					<AccordionSummary className="accordion-header">{renderTitleWithIcon("panel3", "B.3 Fuel Consumers description")}</AccordionSummary>
					<AccordionDetails>
						<FeuB3Consumers
							onFieldAutoSave={handleAutoSave}
							b3FuelConsumerData={data?.b3EmissionSources}
							b3FuelConsumerValues={dropdownData}
							refetchMonitoringData={refetchMonitoringData}
							ref={autoSaveForB3}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>

				<Accordion expanded={expandedPanel === "panel3.1"} onChange={handleChange("panel3.1")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon("panel3.1", "Emission factors referred to in Annex I to Regulation (EU) 2015/757")}
					</AccordionSummary>
					<AccordionDetails>
						<FuelEuEmissionFactors
							onFieldAutoSave={handleAutoSave}
							b31EmissionFactors={data?.b31EmissionFactors}
							fuelOriginMsts={dropdownData?.fuelOrigins}
							fuelBunkerDensities={dropdownData?.fuelBunkeredDensities}
							refetchMonitoringData={refetchMonitoringData}
							ref={autoSaveForB31}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>

				<Accordion expanded={expandedPanel === "panel3.2"} onChange={handleChange("panel3.2")} className="mt-3">
					<AccordionSummary className="accordion-header">{renderTitleWithIcon("panel3.2", "Slippage coefficient")}</AccordionSummary>
					<AccordionDetails>
						<FuelEuSlippageCoefficient
							onFieldAutoSave={handleAutoSave}
							b5SlippageCoefficient={data?.b5SlippageCoefficient}
							reasonForChanges={dropdownData?.reasonForChanges}
							refetchMonitoringData={refetchMonitoringData}
							shouldRefetch={expandedPanel === "panel3.2"}
							fuelTypes={dropdownData?.fuelTypes}
							ref={autoSaveForB32}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel3.3"} onChange={handleChange("panel3.3")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon("panel3.3", "Application of carbon capture and storage technologies")}
					</AccordionSummary>
					<AccordionDetails>
						<FeuCarbonCaptureandStorage
							onFieldAutoSave={handleAutoSave}
							B33CarbonCaptureTechnologies={data?.b33CarbonCaptureTechnologies}
							emissionSourceTypes={dropdownData?.emissionSourceTypes}
							refetchMonitoringData={refetchMonitoringData}
							shouldRefetch={expandedPanel === "panel3.3"}						
							ref={autoSaveForB33}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel3.4"} onChange={handleChange("panel3.4")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon("panel3.4", "Procedures, systems and responsibilities used to update the completeness of fuel consumers")}
					</AccordionSummary>
					<AccordionDetails>
						<FeuFuelConsumerProcedures
							onFieldAutoSave={handleAutoSave}
							b34FuelConsumerData={data?.b34EmissionSourceCompleteness}
							refetchMonitoringData={refetchMonitoringData}
							ref={autoSaveForB34}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel3.5"} onChange={handleChange("panel3.5")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon(
							"panel3.5",
							"Procedures, systems and responsibilities used to determine and update emission factors in accordance with Annex I to Regulation (EU) 2015/757"
						)}
					</AccordionSummary>
					<AccordionDetails>
						<FeuEmissionFactorAnnex1
							onFieldAutoSave={handleAutoSave}
							B35EmissionFactorProcedure={data?.b35EmissionFactorProcedure}
							refetchMonitoringData={refetchMonitoringData}
							ref={autoSaveForB35}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel3.6"} onChange={handleChange("panel3.6")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon(
							"panel3.6",
							"Procedure used to determine the CO2 emission factors of biofuels and RFNBOs/RCFs referred to in Part C, point 1.2, of Annex II to Regulation (EU) 2015/757"
						)}
					</AccordionSummary>
					<AccordionDetails>
						<FeuEmissionFactorAnnex2
							onFieldAutoSave={handleAutoSave}
							B36BiofuelEmissionFactor={data?.b36BiofuelEmissionFactor}
							refetchMonitoringData={refetchMonitoringData}
							ref={autoSaveForB36}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel4"} onChange={handleChange("panel4")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon(
							"panel4",
							"B.4 Equipment to allow connection to on-shore power supply (Only mandatory for container ships and passenger ships )"
						)}
					</AccordionSummary>
					<AccordionDetails>
						<FeuB4OnShorePowerSupply
							onFieldAutoSave={handleAutoSave}
							b4OnShorePowerSupplyValues={dropdownData}
							b4OnShorePowerSupplydata={data?.b4OnshorePowerSupplyEquipments}
							refetchMonitoringData={refetchMonitoringData}
							ref={autoSaveForB4}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel5"} onChange={handleChange("panel5")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon("panel5", "B.5 Zero-emission technology (ZET) (Only mandatory for container ships and passenger ships)")}
					</AccordionSummary>
					<AccordionDetails>
						<FeuB5ZeroEmission
							onFieldAutoSave={handleAutoSave}
							b5ZeroEmission={data?.b5ZeroEmissionTechnologies}
							b5ZeroEmissiondropdown={dropdownData}
							refetchMonitoringData={refetchMonitoringData}
							shouldRefetch={expandedPanel === "panel5"}
							ref={autoSaveForB5}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel6"} onChange={handleChange("panel6")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon(
							"panel6",
							"B.6 Established total electrical power demand of the ship at berth (Only mandatory for container ships and passenger ships )"
						)}
					</AccordionSummary>
					<AccordionDetails>
						<FeuB6PowerDemandAtBerth
							onFieldAutoSave={handleAutoSave}
							b6PowerDemandAtBerth={data?.b6ElectricalPowerAtBerth}
							refetchMonitoringData={refetchMonitoringData}
							ref={autoSaveForB6}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel7"} onChange={handleChange("panel7")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon("panel7", "B.7 Description of Wind Assisted Propulsion Systems (WAPS)(When applicable)")}
					</AccordionSummary>
					<FeuB7WindAssistedPropulsion
						onFieldAutoSave={handleAutoSave}
						b7FuelWindData={data?.b7WapsDescription}
						refetchMonitoringData={refetchMonitoringData}
						b7WindAssistedPropulsionDropdown={dropdownData}
						ref={autoSaveForB7}
						vesselMstId={vesselMstId}
					/>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel8"} onChange={handleChange("panel8")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon(
							"panel8",
							"B.8 Procedures, systems and responsibilities used to update the completeness of the list of fuel consumers, OPS equipment, zero-emission technology and WAPS"
						)}
					</AccordionSummary>
					<AccordionDetails>
						<FeuB8EmissionfactorsAnnex1
							onFieldAutoSave={handleAutoSave}
							b8EmissionFactorsData={data?.b8ConsumerListUpdateProcedures}
							refetchMonitoringData={refetchMonitoringData}
							ref={autoSaveForB8}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>
				<Accordion expanded={expandedPanel === "panel9"} onChange={handleChange("panel9")} className="mt-3">
					<AccordionSummary className="accordion-header">
						{renderTitleWithIcon(
							"panel9",
							"B.9 Procedures for monitoring and reporting the well-to-tank and tank-to-wake emission factors of energy to be used on-board, in accordance with the methods specified in Article 10 and Annexex I and II"
						)}
					</AccordionSummary>
					<AccordionDetails>
						<FeuB9EmissionfactorsAnnex2
							onFieldAutoSave={handleAutoSave}
							b9FuelEmissionFactorsData={data?.b9EmissionFactorMonitoringProcedures}
							refetchMonitoringData={refetchMonitoringData}
							ref={autoSaveForB9}
							vesselMstId={vesselMstId}
						/>
					</AccordionDetails>
				</Accordion>
			</form>
		</FormProvider>
	);
};

export default BasicData;
